export const theme = {
    colors: {
        themeColor: '#4b1e79',
        themeColorBlack: '#333333',
        themeColorGreen: '#38cb89',
        textColor: '#696969',
        headingColor: '#333333',
        headingColorTwo: '#E39A35',
        headingColorDefault: '#4b1e79',
        subHeadingColor: '#6d70a6',
        borderColor: '#ededed',
        borderColorTwo: '#f8f8f8',
        borderDash: '#dddddd',
        white: '#ffffff',
        black: '#000000',
        primary: '#004395',
        secondary: '#E39A35',
        success: '#28a745',
        info: '#17a2b8',
        warning: '#ffc107',
        danger: '#dc3545',
        light: '#f8f9fa',
        bodyBgColor: '#ffffff',
        gray: '#F8F8F8',
        grayTwo: '#F6FAFE',
        grayThree: '#f6f2ed',
        silver: '#ababab',
        silverTwo: '#cccccc',
        kimberly: '#6d70a6',
        spring: '#F6F2ED',
        pattens: '#def0ff',
        yellow: '#ffb944'
    },
    lineHieghts: {
        text: 1.74,
        heading: 1.41
    },
    fontFamily: {
        text: "'Lato', sans-serif",
        heading: "'Lato', sans-serif",
        fontAwesomePro: 'Font Awesome 5 Pro',
        fontAwesomeBrand: 'Font Awesome 5 Brands'
    },
    fontSizes: {
        text: '15px',
        h1: '56px',
        h2: '48px',
        h3: '40px',
        h4: '34px',
        h5: '24px',
        h6: '18px'
    },
    fontWeight: {
        text: 400,
        heading: 700
    },
    transition: 'all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1)'
}

const size = {
    xxlargeMin: "1700px",
    xxlargeMax: "1699px",

    xlargeMin: "1600px",
    xlargeMax: "1699px",

    largeMin: "1200px",
    largeMax: "1599px",

    mediumMin: "992px",
    mediumMax: "1199px",

    smallMin: "768px",
    smallMax: "991px",

    xsmallMin: "576px",
    xsmallMax: "767px",

    xxsmallMin: "481px",
    xxsmallMax: "575px",
};

export const device = {
    xxlarge: `(max-width: ${size.xxlargeMax})`,
    xlarge: `(max-width: ${size.xlargeMax})`,
    large: `(max-width: ${size.largeMax})`,
    medium: `(max-width: ${size.mediumMax})`,
    small: `(max-width: ${size.smallMax})`,
    xsmall: `(max-width: ${size.xsmallMax})`,
    xxsmall: `(max-width: ${size.xxsmallMax})`,

    xxlargeOnly: `(min-width: ${size.xxlargeMin}) and (max-width: ${size.xxlargeMax})`,
    xlargeOnly: `(min-width: ${size.xlargeMin}) and (max-width: ${size.xlargeMax})`,
    largeOnly: `(min-width: ${size.largeMin}) and (max-width: ${size.largeMax})`,
    mediumOnly: `(min-width: ${size.mediumMin}) and (max-width: ${size.mediumMax})`,
    smallOnly: `(min-width: ${size.smallMin}) and (max-width: ${size.smallMax})`,
    xsmallOnly: `(min-width: ${size.xsmallMin}) and (max-width: ${size.xsmallMax})`,
    xxsmallOnly: `(min-width: ${size.xxsmallMin}) and (max-width: ${size.xxsmallMax})`,
};
